import $ from 'jquery';
// ログイン時に表示するモーダル
const onShowExtra = (modalDom, modal) => {
    // 初回ログインのダイアログ表示済みを記録する
    $.ajax({
        headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
        url: '/ajax/users/updateFlgFirstExplanation',
        type: 'POST',
        dataType: 'json',
    })
        .done((data) => {
            if (data['result'] == 'success') {
            } else if (data['result'] == 'nologin') {
                $.toast({
                    heading: 'ログインしていません',
                    text: 'ログインしていません',
                    showHideTransition: 'slide',
                    icon: 'info',
                    position: 'bottom-right',
                    hideAfter: 6000,
                });
            }
        })
        .fail((data) => {
            $.toast({
                heading: '初回ログイン処理に失敗しました',
                text: '初回ログイン処理に失敗しました',
                showHideTransition: 'slide',
                icon: 'error',
                position: 'bottom-right',
                hideAfter: 6000,
            });
        })
        .always((data) => {});
};

const modalFirstLogin = {
    modalId: 'modal-first-login',
    preventEscapeKey: false,
    onShowExtra,
    onCloseExtra: null,
    setup: null,
};

export default modalFirstLogin;
